import React, { useState } from 'react';
import '../../../assets/guestportal.css';

const categories = [
  "All",
  "general",
  "Subscription",
  "Product & Pricing",
  "Security"
];

const items = [
  {
    title: "What is a Sleeve in DocuSafe.ai?",
    content:
      "A Sleeve in DocuSafe.ai is a set of document or information requests sent to one or multiple recipients. You can use a Sleeve to request documents, information, or e-signatures from others in one organized batch.",
    category: "general",
  },
  {
    title: "Who are Recipients in DocuSafe.ai?",
    content:
      "Recipients are individuals or clients from whom you are requesting documents, information, or signatures via a Sleeve.",
    category: "general",
  },
  {
    title: "What are Templates in DocuSafe.ai?",
    content:
      "Templates in DocuSafe.ai allow you to reuse pre-configured document requests for future use. This is useful for processes you run regularly, such as requesting similar documents from multiple clients.",
    category: "general",
  },
  {
    title: `What does \"Fulfilled Sleeve\" mean, and how is it charged?`,
    content: "A Fulfilled Sleeve refers to a scenario where at least one document is uploaded by a recipient in response to your request. Even if you request multiple documents, only one credit is charged once a recipient uploads at least one document.",
    category: "general",
  },
  // Subscription
  {
    title: "How do I sign up for DocuSafe.ai?",
    content:
      `You can sign up by visiting the DocuSafe.ai website and clicking on the "Get Started" or "Free Register" button. Follow the steps to create your account using your email. No credit card is needed for setup, and you will receive 3 free Sleeves per month with the free plan.`,
    category: "Subscription",
  },
  {
    title: "How many Sleeves do I get with the free subscription?",
    content: "With the free subscription, you receive 3 free Sleeves per month.",
    category: "Subscription",
  },
  {
    title: "What happens when I run out of credits?",
    content: "After you exhaust your credits on DocuSafe.ai, you won't be able to send any more Sleeves or request documents, information, or e-signatures until you upgrade your plan. However, you will still have access to your previously collected documents and can manage them within the platform.",
    category: "Subscription",
  },
  {
    title: "Is email verification required for registration?",
    content: "Yes, email verification is required to ensure the security and authenticity of your DocuSafe.ai account.",
    category: "Subscription",
  },
  // Product & Pricing
  {
    title: "Can I request documents from multiple people simultaneously?",
    content: "Yes, you can request documents from multiple people simultaneously by adding multiple recipients in one Sleeve.",
    category: "Product & Pricing",
  },
  {
    title: " How many documents and recipients can I add in one Sleeve?",
    content: `The limits vary by plan:\n      -> Free Plan: Up to 20 documents and 5 recipients.\n      -> Pro Plan: Up to 30 documents and 15 recipients.\n      -> Team Plan: Up to 50 documents and 30 recipients.\n    `,
    category: "Product & Pricing",
  },
  {
    title: "Does DocuSafe.ai integrate with any cloud applications?",
    content: "Yes, DocuSafe.ai integrates with popular cloud storage services such as Google Drive, OneDrive, Dropbox, and Box, allowing for seamless document management and storage.",
    category: "Product & Pricing",
  },
  {
    title: "Can I get a refund after purchasing a plan?",
    content: "Unfortunately, DocuSafe.ai does not offer refunds after purchasing a plan.",
    category: "Product & Pricing",
  },
  {
    title: "How do I upgrade my plan?",
    content:`You can easily upgrade your plan by logging into your account, navigating to the "Billing" section, and selecting the desired plan upgrade option.`,
    category: "Product & Pricing",
  },
  {
    title: " How do I cancel my subscription?",
    content:`To cancel your subscription, log into your DocuSafe.ai account, go to the "Billing" section, and select "Cancel Subscription."`,
    category: "Product & Pricing",
  },
  // Security
  {
    title: "How secure is my data with DocuSafe.ai?",
    content: "DocuSafe.ai uses bank-grade encryption for data protection and includes a secure, passcodeprotected client portal. Two-Factor Authentication (2FA) adds an additional layer of protection. The platform also offers a detailed audit trail to track all actions, ensuring complete transparency and security", 
    category: "Security",
  },
  {
    title: "Does DocuSafe.ai have an auto-tag feature for documents?",
    content: "Yes, our system generates automatic tags from relevant words in the document to facilitate better document management. You can also edit or add tags yourself.",
    category: "Security",
  },
  {
    title: "Can multiple people receive notifications for the same invite?",
    content: "While DocuSafe.ai sends notifications to the designated recipient, you can set up email forwarding rules in your email client to allow multiple people to receive notifications for the same invite.",
    category: "Security",
  },
  {
    title: "When are reminder texts sent out?",
    content: "Reminder texts are sent out around 2/3 PM in the time zone where the user is hosted.",
    category: "Security",
  },
  {
    title: "What security measures prevent malicious content from being uploaded to the DocuSafe.ai portal?",
    content: "All uploads are scanned by antivirus software to prevent malicious content from being uploaded into the DocuSafe.ai portal.",
    category: "Security",
  },
  {
    title: "Can DocuSafe.ai be accessed from any browser, including DuckDuckGo?",
    content: `DocuSafe.ai is accessible from most modern browsers. DuckDuckGo, which focuses on privacy, should be compatible with DocuSafe.ai.\n    \n    This expanded FAQ section aims to address common questions and provide clarity to your customers, enhancing their experience with DocuSafe.ai.`,
    category: "Security",
  },
];

const FAQ2 = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredItems = selectedCategory === "All"
    ? items
    : items.filter(item => item.category === selectedCategory);

  return (
    <section className="modern-faq-section">
      <div className="container">
        <h2 className="modern-faq-title">Frequently Asked Questions</h2>
        <div className="modern-faq-categories">
          {categories.map(cat => (
            <button
              key={cat}
              className={`modern-faq-category-btn${selectedCategory === cat ? ' active' : ''}`}
              onClick={() => setSelectedCategory(cat)}
            >
              {cat === "general" ? "General" : cat}
            </button>
          ))}
        </div>
        <div className="modern-faq-list">
          {filteredItems.map((item, idx) => (
            <div className={`modern-faq-card${openIndex === idx ? ' open' : ''}`} key={idx}>
              <button
                className="modern-faq-question"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                aria-expanded={openIndex === idx}
              >
                <span>{item.title}</span>
                <span className="modern-faq-icon">
                  <span className={`modern-faq-toggle${openIndex === idx ? ' open' : ''}`}></span>
                </span>
              </button>
              <div
                className="modern-faq-answer"
                style={{
                  maxHeight: openIndex === idx ? '400px' : '0',
                  padding: openIndex === idx ? '12px 0 16px 0' : '0 0'
                }}
              >
                <p>{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ2;
